module.exports = __webpack_public_path__ + "img/minus_btn.64ce4a02.png";